<div *ngIf="vm" class="qr-scanner-dialog-container">
  <p class="text-center" mat-dialog-title>{{ vm.title }}</p>

  <mat-dialog-content>
    <div class="scanner-container">
      <zxing-scanner
        #scanner
        id="qr-scanner"
        (scanSuccess)="scanSuccessHandler($event)">
      </zxing-scanner>
      <div #focusFrame *ngIf="vm.zoomFlag" class="focus-frame"></div>
      <div *ngIf="vm.zoomFlag" class="zoom-controls">
        <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="zoomIn()">
          <span aria-hidden="true" class="fa fa-search-plus"></span>
        </button>
        <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="zoomOut()">
          <span aria-hidden="true" class="fa fa-search-minus"></span>
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-center mt-3">
    <button
      class="cancel-button-color dialog-action-button"
      mat-dialog-close
      mat-raised-button
      type="button"
      (click)="onCancel()"
    >Close</button>
  </mat-dialog-actions>
</div>
